export const SHOW_INLINE_IMAGE_LOADER = 'SHOW_INLINE_IMAGE_LOADER';
export const REMOVE_INLINE_IMAGE_LOADER = 'REMOVE_INLINE_IMAGE_LOADER';
